<!--  -->
<template>
  <div class="contianer">
    <div class="con">
      <img
        class="bgimg"
        src="../../assets/images/kf/1080_01.jpg"
        alt=""
        @click="goto('22046')"
      />
      <img
        class="bgimg"
        src="../../assets/images/kf/1080_02.jpg"
        alt=""
        @click="goto('22046')"
      />
      <img
        class="bgimg"
        src="../../assets/images/kf/1080_03.jpg"
        alt=""
        @click="goto('22046')"
      />
      <img
        class="bgimg"
        src="../../assets/images/kf/1080_04.jpg"
        alt=""
        @click="goto('22046')"
      />
      <img
        class="bgimg"
        src="../../assets/images/kf/1080_05.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goto(id) {
      let position = window.scrollY;
      this.$router.push({ query: { page: position } });
      this.$router.push({
        path: "/productDetails?id=" + id,
      });
    },
  },
  created() {},
  mounted() {
    let recruitScrollY = this.$route.query.page;
    window.scroll(0, recruitScrollY);
  },
};
</script>
<style lang='scss' scoped>
img {
  border: 0;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  width: 100%;
}
.con {
  .ac1_img,
  .ac2_img {
    display: flex;
    img {
      cursor: pointer;
    }
  }
  .ac3_img {
    display: flex;
    img {
      cursor: pointer;
    }
  }
}
</style>